import { Keys, Scene } from "excalibur";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import { goToScene } from "../../main";
import Dialog from "../../ui/dialog";
import {
  hiveState,
  inventoryState,
  playerState,
} from "../../state/stateManager";
import {
  createGainedItem,
  getRandomBetween,
  sendAlert,
  startStingTimer,
} from "../../utils";
import { Resources } from "../../Resources";

export default class AskGrandpa extends Scene {
  constructor() {
    super();
    const player = new Player(350, 170, () => {
      this.setPlayerAnim(false);
    });
    this.player = player;

    this.player.z = 3;
    this.player.cutScene = true;
    this.advising = false;
    this.activeItem = 0;
    this.selected = null;
    this.menuItems = 1;

    this.playerAnim = false;
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }

  onActivate(data) {
    console.log("data from activation: ", data);
    this.advising = false;
    this.inventory = inventoryState.getInventory();
    this.treatmentsAvailable = this.inventory.treatments;
    this.hiveStats = data.data;
    const hive = new OpenHive(335, 170, this.hiveStats);
    this.hive = hive;
    this.camera.zoom = 4;
    this.add(this.player);

    this.add(this.hive);
    this.menuContainer = document.getElementById("hive-menu-container");
    this.menuContainer.style.display = "flex";
    this.AskGrandpaMenu = document.getElementById("mite-menu");
    console.log("AskGrandpaMenu: ", this.AskGrandpaMenu);
    this.AskGrandpaMenu.style.display = "block";
    this.AskGrandpaMenu.innerHTML = `<h1>Hive: ${this.hiveStats.id}</h1>
        
        ${showAskGrandpaMenu(0)}
        `;
    if (this.hiveStats.alive) {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "menu",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.stopTimer();
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onDeactivate() {
    this.selected = null;
    this.stingTimer && this.stingTimer.stop();
    this.activeItem = 0;
    this.hive.kill();
  }
  onPreUpdate() {
    if (!this.playerAnim) {
      this.player.doAnim("leftIdleBobble");
    }
  }
  getGrandpaAdvice() {
    let advice = [];
    console.log("advice: getting advice: ", this.hiveStats);
    if (this.hiveStats.foodFrames.count < 0.2) {
      console.log("advice: low food");
      advice.push(`You should feed, they're lookin' pretty dry`);
    }
    if (
      this.hiveStats.beeFrames.count >
      this.hiveStats.overallFrames.count * 0.75
    ) {
      console.log("advice: cramped");
      advice.push(
        `It looks like they might be cramped, consider adding a box or taking a split.`
      );
    }
    if (
      this.hiveStats.foodFrames.count >
      this.hiveStats.overallFrames.queenAccess * 0.4
    ) {
      console.log("advice: honeybound");
      advice.push(
        `They might be getting honeybound. Better get in the brood nest and see if you need to remove some honey.`
      );
    }
    if (this.hiveStats.queenCells.count > 0) {
      advice.push(
        `It looks like they might have some queen cells, is this by design or do you need to take some action?`
      );
    }
    let miteCount = Math.ceil(
      (this.hiveStats.miteCount / this.hiveStats.beeFrames.count) * 2
    );
    if (miteCount > 4) {
      advice.push(`They could probably use a mite wash and maybe a treatment`);
    }
    if (advice.length == 0) {
      advice = ["Everything looks good."];
    }
    return advice;
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      console.log("AskGrandpa: pressed up");
      Resources.Click.play();
      if (this.activeItem === 0) {
        this.activeItem = this.menuItems - 1;
      } else {
        this.activeItem = this.activeItem - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      Resources.Click.play();
      console.log("AskGrandpa: Pressed down");
      if (this.activeItem === this.menuItems - 1) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      console.log("AskGrandpa: pressed enter");
      if (!this.advising) {
        let advice = this.getGrandpaAdvice();
        if (advice == []) {
          advice = ["Looks good. Keep It up."];
        }
        console.log("advice: advice after getGrandpaAdvice: ", advice);
        this.advising = true;
        this.greetingDialog = new Dialog(
          advice,
          () => {
            this.advising = false;
          },
          "grandpa",
          "bottom"
        );
      } else {
        this.greetingDialog.enterPress();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      this.AskGrandpaMenu.style.display = "none";
      this.menuContainer.style.display = "none";
      this.selected = null;
      this.activeItem = 0;
      if (this.advising) {
        this.greetingDialog.destroy();
      }
      goToScene("hiveMenu", this.hiveStats);
    }
  }
}

function showAskGrandpaMenu(active) {
  if (active === 0) {
    return `<h3>Ask Grandpa</h3><ul>
          <li id="list0"><span id="selector">></span> Grandpa Advice</li>
          
        
        </ul>`;
  }
}
